import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";

export class UserDeleteInput extends LanguageInput
{
  email:string;
  tokenID:string;
  password:string;
}

export class UserDeleteRequest extends PHPRequest<PHPAdress,UserDeleteInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_DELETE_ACCOUNT;

  constructor(){ super( UserDeleteRequest.ADRESS ); }
}
